import { render, staticRenderFns } from "./MinutasPronostico.vue?vue&type=template&id=2afad97c&scoped=true"
import script from "./MinutasPronostico.vue?vue&type=script&lang=ts"
export * from "./MinutasPronostico.vue?vue&type=script&lang=ts"
import style0 from "./MinutasPronostico.vue?vue&type=style&index=0&id=2afad97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afad97c",
  null
  
)

export default component.exports